import { ZodSchema, ZodTypeDef, ZodError, ZodIssue } from 'zod';
import { ZodValidationError } from '@common/errors/ZodValidationError';
import { cloneError } from '@common/utils/cloneError';

export const dedupeZodError = (zodError: ZodError) => {
  const dedupedIssues: ZodIssue[] = [];
  const dedupedErrorsMap = new Set();

  zodError.issues.forEach(issue => {
    const { path, message } = issue;
    const filteredPath = path.map(el => (typeof el === 'number' ? '[]' : el));
    const key = `${filteredPath}:${message}`;
    if (!dedupedErrorsMap.has(key)) {
      dedupedErrorsMap.add(key);
      dedupedIssues.push({
        ...issue,
        path: filteredPath,
      });
    }
  });

  return dedupedIssues;
};

export const parse = <Output, Def extends ZodTypeDef = ZodTypeDef, Input = Output>(
  schema: ZodSchema<Output, Def, Input>
) => async (array: Input, error?: Error): Promise<Output> => {
    try {
      return schema.parseAsync(array);
    } catch (zodError: unknown) {
      if (error) {
        if (zodError instanceof ZodError) {
          const zodValidationError = cloneError(error, ZodValidationError, dedupeZodError(zodError));
          return Promise.reject(zodValidationError);
        }
        return Promise.reject(error);
      }
      if (zodError instanceof ZodError) {
        zodError.issues = dedupeZodError(zodError);
        return Promise.reject(zodError);
      }
      return Promise.reject(zodError);
    }
  };
